import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "select__head" }
const _hoisted_2 = {
  key: 0,
  class: "select__option disabled selected",
  "data-value": ""
}
const _hoisted_3 = ["data-value", "onClick"]

import {computed, nextTick, onMounted, onUnmounted, PropType, ref, watch} from "vue";
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import ProLabel from "@/components/UI/Label/ProLabel.vue";

type Option = {
  value: string,
  text: string,
  disabled?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: /*@__PURE__*/_mergeModels({
  placeholder: String,
  active: Boolean,
  position: {
    type: String as PropType<'top' | 'bottom'>,
    default: 'bottom'
  },
  scrollPosition: {
    type: String as PropType<'nearest' | 'center'>,
    default: 'center'
  },
  options: {
    type: Array as PropType<Option[]>,
    required: true
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const props = __props
const [model] = _useModel(__props, "modelValue")
const isOpen = ref(false)
const selectRef = ref<HTMLElement>()
const selectedOption = computed(() => props.options!.find(option => option.value === model.value))
const selectOption = (option: Option) => {
  if (option.disabled) return
  model.value = option.value
  isOpen.value = false
}

const handleClickOutside = (event) => {
  if (!selectRef.value!.contains(event.target)) {
    isOpen.value = false
  }
}
watch(() => isOpen.value, async (opened) => {
  if (opened) {
    await nextTick()
    selectRef.value!.querySelector('.select__option.selected')?.scrollIntoView({block: props.scrollPosition})
  }
})
const isSelected = (value: string) => {
  return value === model.value
}
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select", {active: __props.active}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
    ref_key: "selectRef",
    ref: selectRef
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(selectedOption.value?.text || __props.placeholder), 1),
    _withDirectives(_createVNode(_unref(simplebar), {
      "data-simplebar-auto-hide": "false",
      class: _normalizeClass([[__props.position], "select__options"])
    }, {
      default: _withCtx(() => [
        (__props.placeholder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.placeholder), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["select__option", {active: !(option.disabled), selected : isSelected(option.value)}]),
            key: option.value,
            "data-value": option.value,
            onClick: _withModifiers(($event: any) => (selectOption(option)), ["stop"])
          }, [
            _createTextVNode(_toDisplayString(option.text) + " ", 1),
            (option.disabled)
              ? (_openBlock(), _createBlock(ProLabel, {
                  key: 0,
                  class: "label"
                }))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["class"]), [
      [_vShow, isOpen.value]
    ])
  ], 2))
}
}

})